/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import { Modal } from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
// ====== end of project component import section ====== //

// ========= action import section ========= //
import { doBuyCompletions } from '../../../actions/dashboardAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataHistoryInterface from '../../../interface/reducers/history';
import { ShippingTrackingInterface } from '../../../interface/shipping';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
// ====== end of interface import section ====== //

import PAST_ICON from '../../../images/past-shipping.png';
import CURRENT_ICON from '../../../images/current-shipping.png';

type stateToProps = {
  dataHistory: DataHistoryInterface;
  shippingTrackingData: ShippingTrackingInterface;
  doCompleteShipping: (saleId: string) => Promise<any>;
};

interface ModalShippingTracking {
  isOpen: boolean;
  isDeliverying?: boolean;
  onToggle: () => any;
  onToggleParent: () => any;
  data: {
    orderId: string;
    shippingCourier: string;
    shippingCourierWarehouseToBuyer: string;
    saleId: number;
    awb: string | number;
  };
  callback: () => any;
}

type TProps = ModalShippingTracking & stateToProps;

/**
 * Modal for Buying Pending Detail on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalShippingTracking} props for this component.
 * @return {JSX.Element}
 */
function ModalShippingTrackingComponent(
  props: ModalShippingTracking,
): JSX.Element {
  const {
    isOpen,
    onToggle,
    data,
    shippingTrackingData,
    doCompleteShipping,
    callback,
    isDeliverying,
    onToggleParent,
  } = props as TProps;
  // If data is available, then show the modal
  if (shippingTrackingData) {
    const { orderId, shippingCourierWarehouseToBuyer, awb } = data;
    const onSubmitComplete = () => {
      doCompleteShipping(shippingTrackingData.sale_id).then(() => {
        if (onToggleParent) onToggleParent();
        callback();
      });
    };

    const showReceiveButton =
      isDeliverying || shippingTrackingData.status == 'delivered';

    return (
      <Modal
        className="shipping-tracking-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <div className={'body'}>
          <div className={'header-section'}>
            <div className={'left'}>
              <p className={'product-title'}>Tracking</p>
            </div>
            <div className={'right'}></div>
          </div>
          <div className={'product-detail-section'}>
            <div className={'product-detail-container'}>
              <div className={'product-detail'}>
                <p className={'title'}>Order ID</p>
                <p className={'value'}>{orderId ? orderId : '-'}</p>
              </div>
              <div className={'product-detail'}>
                <p className={'title'}>Delivered at</p>
                <p className={'value'}>
                  {shippingTrackingData.delivered_at
                    ? moment(shippingTrackingData.delivered_at).format(
                        'MMMM DD, YYYY',
                      )
                    : '-'}
                </p>
              </div>
            </div>
            <div className={'product-detail-container'}>
              <div className={'product-detail no-mb'}>
                <p className={'title'}>Shipping Courier</p>
                <p className={'value'}>
                  {shippingCourierWarehouseToBuyer
                    ? shippingCourierWarehouseToBuyer
                    : '-'}
                </p>
              </div>
              <div className={'product-detail no-mb'}>
                <p className={'title'}>AWB Number</p>
                <p className={'value'}>{awb}</p>
              </div>
            </div>
          </div>
          <div className={'delivery-status-section'}>
            <p className={'title'}>Delivery Status</p>
            <div className={'delivery-status-container'}>
              {shippingTrackingData.history.map((item, index) => {
                let itemClass = 'delivery-status-item';
                let imageIcon = PAST_ICON;
                if (index === 0) {
                  itemClass = 'delivery-status-item-active';
                  imageIcon = CURRENT_ICON;
                }
                return (
                  <div key={index} className={itemClass}>
                    <div className={'image-left'}>
                      <KickImage src={imageIcon} />
                    </div>
                    <div className={'description-right'}>
                      <div className={'border-helper'} />
                      <p className={'location'}>{item.location}</p>
                      <p className={'date'}>
                        {moment(item.logged_at).format('MMMM DD, YYYY HH:mm')}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {showReceiveButton && (
            <div className={'bottom-button-section'} onClick={onSubmitComplete}>
              <div className={'confirm-payment-button'}>
                <p>I have received my package</p>
              </div>
            </div>
          )}
        </div>
        <div className={'close-button'} onClick={onToggle}>
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state: stateToProps) => {
  return {
    shippingTrackingData: state.dataHistory.shippingTrackingData.data,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doCompleteShipping: (saleId: string) => dispatch(doBuyCompletions(saleId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalShippingTrackingComponent);
